<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="1000" persistent fluid scrollable content-class="round-2xl")
  v-card(height="90vh")
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center {{ selectedPatient ? $t('edit') : $t('add') }} patient
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog('cancel')" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      v-form(ref="form")
        .mb-2.text-md.font-semibold.neutral700--text Fill in patient information below
        v-row
          v-col
            div.text-sm.font-semibold.neutral500--text.mt-4 Patient image
            div.d-flex.align-center.mt-3
              div(style="width: 70px;")
                v-responsive(:aspect-ratio="7/10")
                  v-card.fill-height.round-xl(v-if="resizeImageFileUrl" flat)
                    v-img(:src="resizeImageFileUrl" height="100%" width="100%")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                  v-card.neutral300.fill-height.round-xl(v-else flat)
                    div.d-flex.align-center.justify-center.fill-height
                      v-icon(size="45") $yzi-user-03
              div.file-change-layout.ml-4
                div(style="width: 120px;")
                  y-button(:label="resizeImageFileUrl ? 'Update image' : 'Add image'" size="xs" outlined block)
                input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 120px !important")

            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('name') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="patient.name" :placeholder="$t('name')" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('nric_passport') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="patient.ic" :placeholder="$t('nric_passport')" outlined dense height="48" :rules="fields.ic ? rules.not_empty : []" hide-details="auto")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
            phone-input.mt-2(v-model="patient.phone" required)
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('email') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="patient.email" :placeholder="$t('email')" outlined dense height="48" hide-details="auto" :rules="(fields.email || Boolean(patient.email)) ? rules.valid_email : []")
            div.text-sm.font-semibold.neutral500--text.mt-4 Date of birth
            v-text-field.text-sm.mt-2.round-xl(v-model="patient.dob" placeholder="dd/mm/yyyy" outlined dense height="48" hide-details="auto" type="date" :rules="fields.dob ? rules.not_empty : []")
            div.text-sm.font-semibold.neutral500--text.mt-4 Gender
            y-select.mt-2(v-model="patient.gender" :items="genders" item-text="text" item-value="value" :placeholder="$t('choose_gender')" :rules="fields.gender ? rules.not_empty_select : []")
            template(v-if="showStaffId")
              div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('staffid') }}
              v-text-field.text-sm.mt-2.round-xl(v-model="patient.staff_id" :placeholder="$t('staffid')" outlined dense height="48" hide-details="auto" )

          v-col
            div.text-sm.font-semibold.neutral500--text.mt-4 Nationality
            y-select.mt-2(v-model="patient.nationality" :items="countries" item-text="name" item-value="name" placeholder="Nationality" :rules="fields.nationality ? rules.not_empty_select : []")
            div.text-sm.font-semibold.neutral500--text.mt-4 Race
            v-row.mt-2(no-gutters style="gap: 12px;")
              v-col.grow
                y-select(v-model="patient.race" :items="races" item-text="text" item-value="value" placeholder="Race" :rules="fields.race ? rules.not_empty_select : []")
              v-col(v-if="patient.race === 'others'" cols="7")
                v-text-field.text-sm.round-xl(v-model="otherRace" placeholder="Race" outlined dense height="48" hide-details="auto" :rules="fields.race ? rules.not_empty : []")
            div.text-sm.font-semibold.neutral500--text.mt-4 Religion
            v-row.mt-2(no-gutters style="gap: 12px;")
              v-col.grow
                y-select(v-model="patient.religion" :items="religions" item-text="text" item-value="value" placeholder="Religion" :rules="fields.religion ? rules.not_empty_select : []")
              v-col(v-if="patient.religion === 'others'" cols="7")
                v-text-field.text-sm.round-xl(v-model="otherReligion" placeholder="Religion" outlined dense height="48" hide-details="auto" :rules="fields.religion ? rules.not_empty : []")
            .address
              div.text-sm.font-semibold.neutral500--text.mt-4 Address
              v-text-field.text-sm.mt-2.round-xl(v-model="address.address_1" :placeholder="$t('address_1.label')" outlined dense height="48" :rules="(fields.address || !emptyAddress) ? rules.not_empty : []" hide-details="auto")
              v-text-field.text-sm.mt-2.round-xl(v-model="address.address_2" :placeholder="$t('address_2.label')" outlined dense height="48" hide-details="auto")
              v-text-field.text-sm.mt-2.round-xl(v-model="address.postcode" :placeholder="$t('postcode.label')" outlined dense height="48" :rules="(fields.address || !emptyAddress) ? rules.not_empty : []" hide-details="auto" @keyup="fetchPostcodes(address.postcode)")
              v-text-field.text-sm.mt-2.round-xl(v-model="address.city" :placeholder="$t('city.label')" outlined dense height="48" :rules="(fields.address || !emptyAddress) ? rules.not_empty : []" hide-details="auto" :loading="isFetchingAddress")
              v-text-field.text-sm.mt-2.round-xl(v-model="address.state" :placeholder="$t('state.label')" outlined dense height="48" :rules="(fields.address || !emptyAddress) ? rules.not_empty : []" hide-details="auto" :loading="isFetchingAddress")
              v-text-field.text-sm.mt-2.round-xl(v-model="address.country" :placeholder="$t('country.label')" outlined dense height="48" :rules="(fields.address || !emptyAddress) ? rules.not_empty : []" hide-details="auto" :loading="isFetchingAddress")
            .emergency-contact
              div.text-sm.font-semibold.neutral500--text.mt-4 Emergency contact name
              v-text-field.text-sm.mt-2.round-xl(v-model="patient.emergency_name" placeholder="Emergency contact name" outlined dense height="48" :rules="fields.emergency_contact ? rules.not_empty : []" hide-details="auto")
              div.text-sm.font-semibold.neutral500--text.mt-4 Emergency contact phone
              phone-input.mt-2(v-model="patient.emergency_phone" :required="fields.emergency_contact")

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(text @click="closeDialog('cancel')") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { resizeImage } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import { countries } from '@/assets/countries.js'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedPatient: {
      type: Object,
      default: null
    }
  },
  components: { PhoneInput },
  data () {
    return {
      isLoading: false,
      isFetchingAddress: false,
      otherRace: null,
      otherReligion: null,
      resizeImageFile: null,
      resizeImageFileUrl: '',
      genders: [
        { text: 'Male', value: 'male' },
        { text: 'Female', value: 'female' },
      ],
      fields: {},
      patient: {},
      address: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      races: 'clinic/getRaces',
      religions: 'clinic/getReligions',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    emptyAddress () {
      if (Object.keys(this.address).length === 0) {
        return true
      } else if (Object.values(this.address).every(val => !val)) {
        return true
      }
      return false
    },
    showStaffId () {
      if (this.company.genes.find(gene => gene.feature === 'show_staff_id_registration')) return true

      return false
    },
    countries () {
      return countries
    },
  },
  mounted () {
    this.fetchFormFields()
    if (this.selectedPatient) {
      let data = JSON.parse(JSON.stringify(this.selectedPatient))
      if (data.race && !['melayu', 'cina', 'india', 'bumiputera'].includes(data.race)) {
        this.otherRace = data.race
        data.race = 'others'
      }
      if (data.religion && !['islam', 'buddha', 'hindu', 'kristian'].includes(data.religion)) {
        this.otherReligion = data.religion
        data.religion = 'others'
      }
      if (data.emergency_contact && Object.keys(data.emergency_contact).length > 0) {
        data.emergency_name = data.emergency_contact?.name || null
        data.emergency_phone = data.emergency_contact?.phone || null
      }
      if (data.address) {
        this.address = data.address
      }
      if (data.profile_image) {
        this.resizeImageFileUrl = data.profile_image.file
      }
      delete data.address
      delete data.profile_image
      delete data.id
      this.patient = data
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    fetchFormFields () {
      this.$axios.get(`/clinics/${this.company.slug}/registrations/form_fields`)
        .then(resp => {
          let fields = {}
          resp.data.forEach(o => {
            fields[o.field] = o.required
          })
          this.fields = fields
        })
    },
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetchingAddress = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.address, 'city', addresses[0].city)
          this.$set(this.address, 'state', addresses[0].state)
          this.$set(this.address, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isFetchingAddress = false
      })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.fields.profile_image && !this.resizeImageFileUrl) {
        this.showMessage(['error', 'Patient image is required'])
        return
      }
      this.isLoading = true
      if (this.selectedPatient) {
        let data = {
          ...this.patient,
        }
        if (this.patient.religion === 'others') {
          data.religion = this.otherReligion
        }
        if (this.patient.race === 'others') {
          data.race = this.otherRace
        }
        if (this.patient.emergency_name || this.patient.emergency_phone) {
          data.emergency_contact = {
            name: this.patient.emergency_name || '',
            phone: this.patient.emergency_phone || ''
          }
        }
        if (!this.emptyAddress){
          data.address = this.address
        }
        if (this.patient.panels.length) {
          data.panels = this.patient.panels
              .filter(item => item.panel)
              .map(item => ({
                panel: item.panel.id,
                staff_id: item.staff_id
              }))
        }
        let formdata = new FormData()
        if (this.resizeImageFile) {
          formdata.append('profile_image', this.resizeImageFile)
        }
        this.$axios.patch(`/clinics/${this.company.slug}/patients/${this.selectedPatient.id}`, data)
          .then(resp => {
            if (this.resizeImageFile) {
              this.$axios.patch(`/clinics/${this.company.slug}/patients/${resp.data.id}`, formdata)
                .catch(() => {})
            }
            this.closeDialog('edit')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        let data = {
          ...this.patient,
          source: 'admin'
        }
        if (this.patient.religion === 'others') {
          data.religion = this.otherReligion
        }
        if (this.patient.race === 'others') {
          data.race = this.otherRace
        }
        if (this.patient.emergency_name || this.patient.emergency_phone) {
          data.emergency_contact = {
            name: this.patient.emergency_name || '',
            phone: this.patient.emergency_phone || ''
          }
        }
        if (!this.emptyAddress){
          data.address = this.address
        }
        let formdata = new FormData()
        if (this.resizeImageFile) {
          formdata.append('profile_image', this.resizeImageFile)
        }
        this.$axios.post(`/clinics/${this.company.slug}/patients`, data)
          .then(resp => {
            if (this.resizeImageFile) {
              this.$axios.patch(`/clinics/${this.company.slug}/patients/${resp.data.id}`, formdata)
                .catch(() => {})
            }
            this.showMessage(['success', 'Patient registered successfully'])
            this.closeDialog('add')
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data?.length > 0) {
              message = err.response.data[0]
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeDialog (action) {
      this.$emit('closed', action)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>